import { Injectable, inject } from '@angular/core';
import { VoiceIntent, VoiceExecutionResult } from '../models';
import { IntentValidatorService } from './intent-validator.service';
import { VoiceModuleHandler } from '../handlers/voice-handler.interface';
import { CalendarVoiceHandler } from '../handlers/calendar-voice.handler';
import { ProjectVoiceHandler } from '../handlers/project-voice.handler';
import { InventoryVoiceHandler } from '../handlers/inventory-voice.handler';
import { RoomsVoiceHandler } from '../handlers/rooms-voice.handler';
import { SessionVoiceHandler } from '../handlers/session-voice.handler';

/**
 * Service de routage des intentions vocales vers les handlers de module.
 * Dispatche chaque intent vers le handler qui supporte l'endpoint.
 */
@Injectable({ providedIn: 'root' })
export class ServiceRouterService {
  private validator = inject(IntentValidatorService);

  private handlers: VoiceModuleHandler[] = [
    inject(CalendarVoiceHandler),
    inject(ProjectVoiceHandler),
    inject(InventoryVoiceHandler),
    inject(RoomsVoiceHandler),
    inject(SessionVoiceHandler),
  ];

  async execute(intent: VoiceIntent): Promise<VoiceExecutionResult> {
    const validation = this.validator.validate(intent);
    if (!validation.valid) {
      return {
        success: false,
        message: validation.errors.join('. ')
      };
    }

    const handler = this.handlers.find(h =>
      h.supportedEndpoints.includes(intent.endpoint)
    );

    if (!handler) {
      return {
        success: false,
        message: `Action non supportée: ${intent.endpoint}`
      };
    }

    try {
      return await handler.execute(intent);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erreur inconnue';
      return {
        success: false,
        message: `Erreur lors de l'exécution: ${message}`
      };
    }
  }
}
